import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { textAlign } from '@mui/system';

const  Loader =({color,size}) =>{
  // #fff
  return (
    <Box textAlign={"center"} >
      <CircularProgress  size={size?size:"10px"} sx={{color:color??"#423A2A"}}/>
    </Box>
  );
}
export default Loader;